import {Component, OnInit, Output, EventEmitter, Inject, PLATFORM_ID} from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { LocalSettingsService } from 'src/app/services/local-settings.service';
import {UserService} from "../../../services/user-services/user.service";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import {HelperService} from "../../../services/helper.service";
import {first, take} from "rxjs/operators";
import {AlertService} from "../../../services/alert.service";
import {AuthenticationService} from "../../../services/authentication.service";
import { isPlatformBrowser, Location, NgClass} from "@angular/common";
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-seo-header',
  templateUrl: './seoHeader.component.html',
  styleUrls: ['./seoHeader.component.scss'],
  standalone: true,
  imports: [NgbDropdownModule, NgClass, RouterLink, TranslateModule]
})
export class SeoHeaderComponent implements OnInit {
  isopened = null;
  isSubMenuOpened = null;
  burgerOpened = false;
  grey = 'en';
  tags;
  currentUser;
  currentLanguage: string;

  constructor(
    private userService: UserService,
    private router: Router,
    private helperService: HelperService,
    public translate: TranslateService,
    private _localSettings: LocalSettingsService,
    private alertService: AlertService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private location: Location,
    @Inject(PLATFORM_ID) private platformId

  ) { }

  @Output() langChanged = new EventEmitter<string>();

  ngOnInit(): void {

    this._localSettings.language$.subscribe(
      (language: string) => {
        this.currentLanguage = language;
      }
    );

    if(isPlatformBrowser(this.platformId)) {
      // UTM
      this.route.queryParams.subscribe(params => {
        if (params && (params['utm_campaign'] || params['utm_source'] || params['utm_medium'])) {
          const utm = [
            { key: 'utm_campaign', value: params['utm_campaign'] ? params['utm_campaign'] : '' },
            { key: 'utm_source', value: params['utm_source'] ? params['utm_source'] : '' },
            { key: 'utm_medium', value: params['utm_medium'] ? params['utm_medium'] : '' },
          ];
          this._localSettings.setUtm(JSON.stringify(utm));
        }
      });

      if (this.authenticationService.currentUserValue) {
        // CAMPAIGN
        this.grey = this._localSettings.getLanguage();
        this.route.queryParams.subscribe(params => {
          if (params && params['campaign']) {
            this._localSettings.setReferer(params['campaign']);
            this.userService.updateReferer(params['campaign']).subscribe();
          }

          //UTM
          const utm = this._localSettings.getUtm();
          if(utm){
            this.userService.updateUtm(JSON.parse(utm)).subscribe();
          }
        });

        this.userService.getDatas()
            .pipe(take(1))
            .subscribe((data) => {
              if (data) {
                this.userService.setInfos(data);
                this.currentUser = data;
                // Translate language
                data.textLanguage = (this.currentLanguage);
                this.translate.use(this.currentLanguage);
                this._localSettings.setLanguage(this.currentLanguage);
              }
            });
      } else {
        const currentLang = this.route.snapshot.paramMap.get('lang');
        if (currentLang) {
          this.grey = currentLang;
        }
      }
    }
  }

  toggleIsOpened(name) {
    this.isopened = this.isopened == name ? null : name;
    this.isSubMenuOpened = false;
  }

  fBurgerOpened() {
    this.burgerOpened = !this.burgerOpened;
  }
  flagToggle(current) {
    this.grey = current;
  }

  openSubMenu(name){
    this.userService.getAllTagsByTopic(name).subscribe((data) => {
      this.tags = data.themes;
      this.isSubMenuOpened = true;
    });
  }

  goToTopic(topic){
    const lang = this._localSettings.getLanguage();
    window.open(this.router.serializeUrl(this.router.createUrlTree([lang + '/' + topic])));
  }

  private isPage(url: string, pageName: string): boolean {
    return url.includes(pageName);
  }

  public useLanguage(language: string) {
    language = language !== 'fr' ? 'en' : 'fr';
    const oldLang = this._localSettings.getLanguage();
    const currentUrl = this.location.path();

    this.translate.use(language);
    this._localSettings.setLanguage(language);

    if (oldLang === language) return;

    const pages = ['blog', 'bourse'];
    const currentPage = pages.find(page => this.isPage(currentUrl, page));

    if (currentPage) {
      this.langChanged.emit(language);
      const newUrl = `/${language}/${currentPage}`;

      if (this.currentUser) {
        this.userService.update({ textLanguage: language })
          .pipe(first())
          .subscribe({
            next: (data: any) => {
              if (data.status === 'error') {
                this.alertService.openSnackBar(data.data, 'snack-error');
              } else {
                this.userService.setInfo('textLanguage', language);
                this.router.navigate([newUrl]);
              }
            },
            error: (error) => this.alertService.openSnackBar(error, 'snack-error')
          });
      } else {
        window.location.href = newUrl;
      }
    } else {
      this.router.navigate([`/${language}`]);
    }
  }

  goToLink(sublink, link){
    this.router.navigate([sublink + link]);
  }

  encodeUrl(url: string){
    return this.helperService.encodeUrl(url);
  }


}
